import {getTeamPublicInfo} from '@/api/api';
import {Team} from '@/user/user.interface';
import {useQuery} from '@tanstack/react-query';

export const useGetTeamPublicInfo = ({teamId}: {teamId?: string}) => {
  return useQuery<Partial<Team>>({
    queryKey: ['team-public', teamId],
    queryFn: () => getTeamPublicInfo({teamId}),
    enabled: !!teamId,
  });
};
